<template>
  <v-card>
    <v-layout column class="pa-4">
      <h2 style="width: 100%; text-align: center;" class="mb-2">Solicitar retirada de saldo</h2>
    </v-layout>
    <v-alert v-show="!dataAutorizada" type="error" style="width: 100%;" class="pa-2" :value="true">
        <h4>Você só pode realizar uma retirada entre os dias 3 a 5, 13 a 15 e 23 a 25.</h4>
    </v-alert>
    <v-form ref="form" v-model="valid">
      <v-container fluid grid-list-xl>
        <v-flex>
          <v-text-field label="Valor de retirada" v-model.lazy="valor" prefix="R$" v-money="money"></v-text-field>
        </v-flex>
        <v-layout row>
          <v-spacer></v-spacer>
          <v-btn color="success" :disabled="disabled" @click="solicitarRetiradaDeSaldo">Solicitar retirada</v-btn>
        </v-layout>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>

import { VMoney } from 'v-money'
import moment from 'moment-timezone'

export default {
  props: ['carteira'],
  directives: { money: VMoney },
  data () {
    return {
      items: [
        {
          value: 'cpf', text: 'CPF'
        },
        {
          value: 'cnpj', text: 'CNPJ'
        },
        {
          value: 'numero_de_telefone', text: 'Número de Telefone'
        },
        {
          value: 'email', text: 'E-mail'
        },
        {
          value: 'chave_aleatoria', text: 'Chave Aleatória'
        }
      ],
      tipo: '',
      chave: '',
      valor: 0.00,
      valor_decimal: 0.00,
      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: false
      },
      valid: false,
      mask: '',
      rules: [],
      requiredRules: [
        v => !!v || 'Você se esqueceu de selecionar o tipo da chave PIX'
      ]
    }
  },
  computed: {
    dataAutorizada () {
      const dataAtual = moment()
      moment.tz.setDefault('America/Recife')
      const dia = dataAtual.date()
      return (
        (dia >= 3 && dia <= 5) ||
        (dia >= 13 && dia <= 15) ||
        (dia >= 23 && dia <= 25)
      )
    },
    disabled () {
      if (!this.dataAutorizada) return true
      if (this.valor_decimal <= 0 || this.valor_decimal > parseFloat(this.carteira.saldo)) return true
      // (valor_decimal <= 0) || (valor_decimal > parseFloat(carteira.saldo))
      return false
    }
  },
  methods: {
    solicitarRetiradaDeSaldo () {
      this.$refs.form.validate()
      if (this.valid) {
        let dados = {
          tipo_chave_pix: this.tipo,
          chave_pix: this.chave,
          valor: this.valor_decimal
        }
        this.$emit('solicitarRetiradaDeSaldo', dados)
      }
    }
  },
  watch: {
    valor (value) {
      this.valor_decimal = value
      this.valor_decimal = this.valor_decimal.replaceAll('.', '')
      this.valor_decimal = this.valor_decimal.replace(',', '.')
    },
    tipo (value) {
      if (value === 'email') {
        this.rules = [
          v => !!v || 'Você se esqueceu de informar o e-mail',
          v => /.+@.+\..+/.test(v) || 'Confira o endereço digitado. Nos parece que não está em um formato válido.'
        ]
        this.mask = ''
      } else if (value === 'cpf') {
        this.rules = [
          v => !!v || 'Você se esqueceu de informar o CPF',
          v => /^[0-9]{11}$/.test(v) || 'Confira o CPF digitado. Nos parece que não está em um formato válido.'
        ]
        this.mask = '###.###.###-##'
      } else if (value === 'numero_de_telefone') {
        this.rules = [
          v => !!v || 'Você se esqueceu de informar o número do telefone',
          v => /^[1-9]{2}9?[0-9]{8}$/.test(v) || 'Confira o número do telefone digitado. Nos parece que ele não é válido.'
        ]
        this.mask = '(##) #####-####'
      } else if (value === 'cnpj') {
        this.rules = [
          v => !!v || 'Você se esqueceu de informar o CNPJ',
          v => /^[0-9]{14}$/.test(v) || 'Confira o CNPJ digitado. Nos parece que ele não está em um formato válido.'
        ]
        this.mask = '##.###.###/####-##'
      } else {
        this.rules = [
          v => !!v || 'Você se esqueceu de preencher este campo'
        ]
        this.mask = ''
      }
    }
  }
}
</script>

<style>
</style>
